import { Component, OnInit } from '@angular/core';
import { DialogService } from "../../shared/services/dialog.service";
import { WorldTravelPopUpComponent } from "./world-travel-detail.popup.component";
import { InformationService } from "./information.service";
import { WorldTravelNews } from '../../models/information/news.models';
import { AppConstants } from '../../shared/constants/constants';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css'],
  providers: [InformationService]
})
export class InformationComponent implements OnInit {

  constructor(
    public dialogService: DialogService,
    public informationService: InformationService
  ) { }

  public messagesWorldTravel = new Array<WorldTravelNews>();
  public appConstants = AppConstants;
  public memo: string;

  ngOnInit() {
    this.getWorldTravelNewList();
    this.geMemoMyTMB();
  }

  getWorldTravelNewList() {
    this.informationService.getAllWorldTravelNew(callback => {
      if (callback) {
        this.messagesWorldTravel = callback;
      }
    });
  }

  geMemoMyTMB() {
    this.informationService.getMyTMBMemo().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.memo = data.value;
        }
      }
    );
  }

  onOpenWorldTravelDialog(message) {
    this.dialogService.openComponentDialog(WorldTravelPopUpComponent,
      {
        id: message.id,
        news: message
      },
      {}).subscribe(
        result => {
          if (result) {
            // this.setPage({ offset: 0 });
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/information/information.component.ts